// Name branding company based on env
export const companyName = (env)=>{
  return env.includes('EJW') ? (env.includes('CHENEY') ? 'Cheney Vrooman' : 'EJ Welch') : 'Lancaster'
}